/* Checkbox strike-through styles */
.checkbox-strike-through {
  top: 45%;
  left: 20%;
  width: 60%;
  height: 2px;
  transition: opacity 0.2s ease;
}
